import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Button } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Tab, Tabs } from 'vant';
import { Grid, GridItem } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { Image as VanImage } from 'vant';
import { Divider } from 'vant';
import { Col, Row } from 'vant';
import { Dialog } from 'vant';
import axios from 'axios'
import { NoticeBar } from 'vant';
import { Sticky } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Uploader } from 'vant';
import { Field } from 'vant';
import { RadioGroup, Radio } from 'vant';
//import { DatetimePicker } from 'vant';
import { Popup } from 'vant';
import { Picker } from 'vant';
import { Empty } from 'vant';
import { NavBar } from 'vant';
import { Loading } from 'vant';
import { Tag } from 'vant';
import { ActionBar, ActionBarIcon, ActionBarButton } from 'vant';
import { Icon } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Toast } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { Overlay } from 'vant';
import { List } from 'vant';
import { Search } from 'vant';
import { CountDown } from 'vant';
import { Slider } from 'vant';
import { ActionSheet} from 'vant';
import { Notify } from 'vant'
import 'vant/lib/index.css'
const app = createApp(App);
app.config.globalProperties.$http = axios;
app.use(store).use(router).mount('#app')
app.use(Notify);
app.use(NoticeBar);
app.use(NoticeBar);
app.use(Sticky);
app.use(Col);
app.use(Row);
app.use(Button);
app.use(Divider);
app.use(VanImage);
app.use(Tabbar);
app.use(TabbarItem);
app.use(Grid);
app.use(GridItem);
app.use(Tab);
app.use(Tabs);
app.use(Swipe);
app.use(SwipeItem);
app.use(Dialog);
app.use(Cell);
app.use(CellGroup);
app.use(Uploader);
app.use(Field);
app.use(Radio);
app.use(RadioGroup);
//app.use(DatetimePicker);
app.use(Popup);
app.use(Picker);
app.use(Empty);
app.use(NavBar);
app.use(Loading);
app.use(Tag);
app.use(ActionBar);
app.use(ActionBarIcon);
app.use(ActionBarButton);
app.use(Icon);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(Toast);
app.use(Collapse);
app.use(CollapseItem);
app.use(Overlay);
app.use(List);
app.use(Search);
app.use(CountDown);
app.use(Slider);
app.use(ActionSheet);

